// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-app>
    <v-container fluid grid-list-md>
      <v-row>
        <v-col cols="12" sm="4" offset-sm="4">
          <v-card>
            <v-card-title>
              <span class="headline">New Password</span>
            </v-card-title>
            <v-card-text>
              Set a new password for {{ username }}:
              <v-text-field
                name="input"
                label="New Password"
                v-model="passwordReset1"
                required
                :rules="[passwordRule, passwordsEqual]"
                type="password"
                counter :min="passwordLength">
              ></v-text-field>
              <v-text-field
                name="input"
                label="Verify New Password"
                v-model="passwordReset2"
                required
                :rules="[passwordRule, passwordsEqual]"
                type="password"
                counter :min="passwordLength">
              ></v-text-field>
              {{ username }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="blue--text darken-1" text @click.native="reset">Set Password</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

    <error-snackbar v-model="errorText"></error-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import {AXIOSAPI} from 'vue-common/components/requests-common'
import ErrorSnackbar from './ErrorSnackbar'
import Rules from './rules'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      passwordLength: Rules.PASSWORDLENGTH,
      passwordReset1: '',
      passwordReset2: '',
      errorText: ''
    }
  },

  computed: {
    passwordsEqual: function () {
      if ((this.passwordReset1 === this.passwordReset2) || this.passwordReset2.length === 0) {
        return true
      } else {
        return 'Passwords are not the same'
      }
    },

    username: function () {
      var token = this.$route.query.token
      var sub = token.substring(64, token.length - 8)
      return this.hex2a(sub)
    }
  },

  methods: {
    reset: function () {
      if (this.passwordReset1.length > 0) {
        if (Rules.password(this.passwordReset1) !== true || this.passwordsEqual !== true) {
          this.errorText = 'Passwords must match'
        } else {
          var user = {}
          user.password = this.passwordReset1
          user.token = this.$route.query.token
          console.log(user)
          AXIOSAPI.post('auth/passwordreset', user).then(response => {
            this.$router.push({name: 'login'})
          }).catch(e => {
            if (e.response.status === 401 && e.response.data !== undefined && e.response.data.reason === 'password too weak') {
              this.errorText = 'Password must be stronger.'
            }
            else {
              this.errorText = 'Your password reset token is invalid, please contact support.'
            }
            console.log(e)
          })
        }
      } else {
        this.errorText = 'Please enter a valid password'
      }
    },

    passwordRule: function (password) {
      return Rules.password(password)
    },

    hex2a: function (hexx) {
      var hex = hexx.toString()
      var str = ''
      for (var i = 0; (i < hex.length && hex.substr(i, 2) !== '00'); i += 2) {
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
      }

      return str
    }
  }
}
</script>



// WEBPACK FOOTER //
// PasswordResetForm.vue?b2e2fd84